export const CACHE_KEY_MANAGER_CREATE_REQUEST_BEFORE_PURCHASE = 'manager-create-request-before-purchase';
